import { lazy } from "react";

const CreateInventoryPage = lazy(() => import("./create"));
const InventoryListPage = lazy(() => import("./main"));
const UpdateInventoryPage = lazy(() => import("./update"));

export {
  CreateInventoryPage, InventoryListPage, UpdateInventoryPage,
};
